import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import { post } from "@rails/request.js"

export default class extends Controller {
  static values = { url: String }

  connect() {
    new Sortable(this.element, {
      handle: ".handle",
      onSort: (ev) => this.onSort(ev)
    })
  }

  async onSort(ev) {
    const response = await post(this.urlValue, {
      body: { id: ev.item.dataset.participante, position: ev.newIndex },
      responseKind: "json"
    })

    if (response.ok) {
      const json = await response.json

      json.forEach((id, i) => {
        const element = document.querySelector(`[data-participante="${id}"] small`)
        if (element) element.textContent = i + 1
      })
    }
  }
}
